import { render, staticRenderFns } from "./box-radio.vue?vue&type=template&id=752d1ee9&scoped=true"
import script from "./box-radio.vue?vue&type=script&lang=js"
export * from "./box-radio.vue?vue&type=script&lang=js"
import style0 from "./box-radio.vue?vue&type=style&index=0&id=752d1ee9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752d1ee9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('752d1ee9')) {
      api.createRecord('752d1ee9', component.options)
    } else {
      api.reload('752d1ee9', component.options)
    }
    module.hot.accept("./box-radio.vue?vue&type=template&id=752d1ee9&scoped=true", function () {
      api.rerender('752d1ee9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/forms/box-radio/box-radio.vue"
export default component.exports